import {
  createStore,
  combineReducers,
  applyMiddleware,
  compose,
} from 'redux';

import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';

import { routerReducer, routerMiddleware } from 'react-router-redux'

import DevTools from 'app/components/common/DevTools';

import rootReducer from './reducers';

const NODE_ENV = process.env.NODE_ENV;
const __DEV__ = NODE_ENV === 'development';

export default (history, initialState = {}) => {
  const customizedPromiseMiddleware = promiseMiddleware({
    promiseTypeSuffixes: ['LOADING', 'SUCCESS', 'FAILURE'],
  });

  const middlewares = [
    thunk,
    customizedPromiseMiddleware,
    routerMiddleware(history),
  ];

  const enhancer = compose(
    applyMiddleware(...middlewares),
    __DEV__ ? DevTools.instrument() : f => f,
  );

  const store = createStore(
    combineReducers({
      ...rootReducer,
      router: routerReducer,
    }),
    initialState,
    enhancer,
  );

  return store;
};



// WEBPACK FOOTER //
// ./src/app/redux/createStore.js